import { Link } from '@mui/material';
import { Footer as SharedFooter } from '@tix-ticketing/ui-components';
import { FormattedMessage } from 'react-intl';
import { LegalDocumentLink } from 'components/common/dialogs/legal-document-link';
import { useAppState } from 'lib/app-state';
import { useVersion } from 'lib/hooks/use-version';
export const Footer = () => {
  const {
    appSettings
  } = useAppState();
  const apiVersion = useVersion();
  const uiVersion = process.env.APP_VERSION;
  return <SharedFooter copyright={appSettings?.name ?? ''} meta={<>
          ui {uiVersion}
          {apiVersion && ` · api ${apiVersion}`}
        </>} links={[<Link key="cookies" href="#">
          <FormattedMessage id="footer.cookiePolicy" defaultMessage={[{
      "type": 0,
      "value": "Cookie policy"
    }]} />
        </Link>, <LegalDocumentLink key="privacy" document="privacyPolicy">
          <FormattedMessage id="footer.privacyPolicy" defaultMessage={[{
      "type": 0,
      "value": "Privacy policy"
    }]} />
        </LegalDocumentLink>, <LegalDocumentLink key="terms" document="termsAndConditions">
          <FormattedMessage id="footer.termsAndConditions" defaultMessage={[{
      "type": 0,
      "value": "Terms & conditions"
    }]} />
        </LegalDocumentLink>]} rightTitle={appSettings?.phoneNumber && <FormattedMessage id="footer.callCentre" defaultMessage={[{
    "type": 0,
    "value": "Call centre "
  }, {
    "type": 1,
    "value": "phoneNumber"
  }]} values={{
    phoneNumber: appSettings.phoneNumber
  }} />} rightSubtitle={appSettings?.openingHours} />;
};